module.exports = __webpack_public_path__ + "img/paris7.e36c3f01.jpeg";